/*using-turbo-watch-with-persistent-tasks*/
/*dependency-aware-persistent-tasks*/
/*persistent-tasks-without-dependency-awareness*/
/*limitations*/
/*caching*/
/*task-outputs*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "watch",
  "description": "`watch` 命令的 API 参考"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "根据代码更改，重新运行代码库中的任务。"
  }, {
    "heading": "",
    "content": "¥Re-run tasks in your repository, based on code changes."
  }, {
    "heading": "",
    "content": "turbo watch 具有依赖感知功能，这意味着任务将按照 turbo.json 中的配置 的顺序重新运行。"
  }, {
    "heading": "",
    "content": "¥turbo watch is dependency-aware, meaning tasks will re-run in the order configured in turbo.json."
  }, {
    "heading": "",
    "content": "如果没有提供任何任务，turbo 将显示存储库中包可用的任务。"
  }, {
    "heading": "",
    "content": "¥If no tasks are provided, turbo will display what tasks are available for the packages in the repository."
  }, {
    "heading": "将-turbo-watch-与持久任务结合使用-using-turbo-watch-with-persistent-tasks",
    "content": "¥Using turbo watch with persistent tasks"
  }, {
    "heading": "将-turbo-watch-与持久任务结合使用-using-turbo-watch-with-persistent-tasks",
    "content": "持久任务标记为 \"persistent\": true，表示它们不会退出。因此，它们在你的任务图中不可依赖。"
  }, {
    "heading": "将-turbo-watch-与持久任务结合使用-using-turbo-watch-with-persistent-tasks",
    "content": "¥Persistent tasks are marked with \"persistent\": true, meaning they won't exit. Because of this, they cannot be depended on in your task graph."
  }, {
    "heading": "将-turbo-watch-与持久任务结合使用-using-turbo-watch-with-persistent-tasks",
    "content": "这意味着使用 turbo watch 时，持久性任务将被忽略，其工作方式与使用 turbo run 时相同，从而允许同时运行持久性任务和非持久性任务。"
  }, {
    "heading": "将-turbo-watch-与持久任务结合使用-using-turbo-watch-with-persistent-tasks",
    "content": "¥This means that persistent tasks will be ignored when using turbo watch, working the same way they do with turbo run, allowing persistent and non-persistent tasks to be run at the same time."
  }, {
    "heading": "依赖感知的持久任务-dependency-aware-persistent-tasks",
    "content": "¥Dependency-aware persistent tasks"
  }, {
    "heading": "依赖感知的持久任务-dependency-aware-persistent-tasks",
    "content": "当你的脚本具有内置的监视程序（例如 next dev）能够检测依赖的变化时，你无需使用 turbo watch。相反，使用脚本的内置监视器，并使用 \"persistent\": true 将任务标记为长时间运行。"
  }, {
    "heading": "依赖感知的持久任务-dependency-aware-persistent-tasks",
    "content": "¥When your script has a built-in watcher (like next dev) capable of detecting changes in dependencies, you don't need to use turbo watch. Instead, use your script's built-in watcher and mark the task as long-running using \"persistent\": true."
  }, {
    "heading": "没有依赖感知的持久任务-persistent-tasks-without-dependency-awareness",
    "content": "¥Persistent tasks without dependency awareness"
  }, {
    "heading": "没有依赖感知的持久任务-persistent-tasks-without-dependency-awareness",
    "content": "某些工具与 monorepo 不兼容，并且不会在依赖中热重载模块。在这种情况下，你应该将任务标记为 interruptible: true，以便在检测到相关更改时让 turbo watch 重新启动该任务。"
  }, {
    "heading": "没有依赖感知的持久任务-persistent-tasks-without-dependency-awareness",
    "content": "¥Some tools aren't monorepo-friendly, and do not hot-reload modules in dependencies. In those cases, you should\nmark the task as interruptible: true to have turbo watch\nrestart the task when relevant changes are detected."
  }, {
    "heading": "限制-limitations",
    "content": "¥Limitations"
  }, {
    "heading": "缓存-caching",
    "content": "¥Caching"
  }, {
    "heading": "缓存-caching",
    "content": "使用监视模式缓存任务目前处于实验阶段，使用 --experimental-write-cache 标志。"
  }, {
    "heading": "缓存-caching",
    "content": "¥Caching tasks with Watch Mode is currently experimental, under the --experimental-write-cache flag."
  }, {
    "heading": "任务输出-task-outputs",
    "content": "¥Task outputs"
  }, {
    "heading": "任务输出-task-outputs",
    "content": "如果你的任务需要写入已签入源代码管理的文件，则监视模式可能会陷入无限循环。这是因为监视模式会监视文件更改，并会在发生更改的包中重新运行任务。如果任务创建了更改，则更改将再次触发该任务。"
  }, {
    "heading": "任务输出-task-outputs",
    "content": "¥If you have tasks that write to files checked into source control, there is a possibility that Watch Mode will run in an infinite loop. This is because Watch Mode watches your\nfiles for changes and will re-run tasks in packages that have changed. If a task creates a change, then that will trigger the task again."
  }, {
    "heading": "任务输出-task-outputs",
    "content": "监视模式有一些逻辑可以使用文件哈希来防止这种情况发生，但这并非万无一失。为避免此问题，我们建议从 git 中删除所有任务输出。"
  }, {
    "heading": "任务输出-task-outputs",
    "content": "¥Watch Mode has some logic to prevent this from happening using file hashes, but it isn't foolproof. To avoid this issue, we recommend removing any task outputs from git."
  }],
  "headings": [{
    "id": "将-turbo-watch-与持久任务结合使用-using-turbo-watch-with-persistent-tasks",
    "content": "将 turbo watch 与持久任务结合使用 /*using-turbo-watch-with-persistent-tasks*/"
  }, {
    "id": "依赖感知的持久任务-dependency-aware-persistent-tasks",
    "content": "依赖感知的持久任务 /*dependency-aware-persistent-tasks*/"
  }, {
    "id": "没有依赖感知的持久任务-persistent-tasks-without-dependency-awareness",
    "content": "没有依赖感知的持久任务 /*persistent-tasks-without-dependency-awareness*/"
  }, {
    "id": "限制-limitations",
    "content": "限制 /*limitations*/"
  }, {
    "id": "缓存-caching",
    "content": "缓存 /*caching*/"
  }, {
    "id": "任务输出-task-outputs",
    "content": "任务输出 /*task-outputs*/"
  }]
};
export const toc = [{
  depth: 2,
  url: "#将-turbo-watch-与持久任务结合使用-using-turbo-watch-with-persistent-tasks",
  title: _jsxs(_Fragment, {
    children: ["将 ", _jsx("code", {
      children: "turbo watch"
    }), " 与持久任务结合使用 "]
  })
}, {
  depth: 3,
  url: "#依赖感知的持久任务-dependency-aware-persistent-tasks",
  title: _jsx(_Fragment, {
    children: "依赖感知的持久任务 "
  })
}, {
  depth: 3,
  url: "#没有依赖感知的持久任务-persistent-tasks-without-dependency-awareness",
  title: _jsx(_Fragment, {
    children: "没有依赖感知的持久任务 "
  })
}, {
  depth: 2,
  url: "#限制-limitations",
  title: _jsx(_Fragment, {
    children: "限制 "
  })
}, {
  depth: 3,
  url: "#缓存-caching",
  title: _jsx(_Fragment, {
    children: "缓存 "
  })
}, {
  depth: 3,
  url: "#任务输出-task-outputs",
  title: _jsx(_Fragment, {
    children: "任务输出 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    p: "p",
    pre: "pre",
    span: "span",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "根据代码更改，重新运行代码库中的任务。"
    }), "\n", _jsx(_components.p, {
      children: "¥Re-run tasks in your repository, based on code changes."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " watch"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [tasks]"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo watch"
      }), " 具有依赖感知功能，这意味着任务将按照 ", _jsxs(_components.a, {
        href: "/docs/reference/configuration",
        children: [_jsx(_components.code, {
          children: "turbo.json"
        }), " 中的配置"]
      }), " 的顺序重新运行。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "turbo watch"
      }), " is dependency-aware, meaning tasks will re-run in the order ", _jsxs(_components.a, {
        href: "/docs/reference/configuration",
        children: ["configured in ", _jsx(_components.code, {
          children: "turbo.json"
        })]
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["如果没有提供任何任务，", _jsx(_components.code, {
        children: "turbo"
      }), " 将显示存储库中包可用的任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If no tasks are provided, ", _jsx(_components.code, {
        children: "turbo"
      }), " will display what tasks are available for the packages in the repository."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " watch"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.h2, {
      id: "将-turbo-watch-与持久任务结合使用-using-turbo-watch-with-persistent-tasks",
      children: ["将 ", _jsx(_components.code, {
        children: "turbo watch"
      }), " 与持久任务结合使用 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Using ", _jsx(_components.code, {
        children: "turbo watch"
      }), " with persistent tasks"]
    }), "\n", _jsxs(_components.p, {
      children: ["持久任务标记为 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#persistent",
        children: _jsx(_components.code, {
          children: "\"persistent\": true"
        })
      }), "，表示它们不会退出。因此，它们在你的任务图中不可依赖。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Persistent tasks are marked with ", _jsx(_components.a, {
        href: "/docs/reference/configuration#persistent",
        children: _jsx(_components.code, {
          children: "\"persistent\": true"
        })
      }), ", meaning they won't exit. Because of this, they cannot be depended on in your task graph."]
    }), "\n", _jsxs(_components.p, {
      children: ["这意味着使用 ", _jsx(_components.code, {
        children: "turbo watch"
      }), " 时，持久性任务将被忽略，其工作方式与使用 ", _jsx(_components.a, {
        href: "/docs/reference/run",
        children: _jsx(_components.code, {
          children: "turbo run"
        })
      }), " 时相同，从而允许同时运行持久性任务和非持久性任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This means that persistent tasks will be ignored when using ", _jsx(_components.code, {
        children: "turbo watch"
      }), ", working the same way they do with ", _jsx(_components.a, {
        href: "/docs/reference/run",
        children: _jsx(_components.code, {
          children: "turbo run"
        })
      }), ", allowing persistent and non-persistent tasks to be run at the same time."]
    }), "\n", _jsx(_components.h3, {
      id: "依赖感知的持久任务-dependency-aware-persistent-tasks",
      children: "依赖感知的持久任务 "
    }), "\n", _jsx(_components.p, {
      children: "¥Dependency-aware persistent tasks"
    }), "\n", _jsxs(_components.p, {
      children: ["当你的脚本具有内置的监视程序（例如 ", _jsx(_components.code, {
        children: "next dev"
      }), "）能够检测依赖的变化时，你无需使用 ", _jsx(_components.code, {
        children: "turbo watch"
      }), "。相反，使用脚本的内置监视器，并使用 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#persistent",
        children: _jsx(_components.code, {
          children: "\"persistent\": true"
        })
      }), " 将任务标记为长时间运行。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When your script has a built-in watcher (like ", _jsx(_components.code, {
        children: "next dev"
      }), ") capable of detecting changes in dependencies, you don't need to use ", _jsx(_components.code, {
        children: "turbo watch"
      }), ". Instead, use your script's built-in watcher and mark the task as long-running using ", _jsx(_components.a, {
        href: "/docs/reference/configuration#persistent",
        children: _jsx(_components.code, {
          children: "\"persistent\": true"
        })
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "没有依赖感知的持久任务-persistent-tasks-without-dependency-awareness",
      children: "没有依赖感知的持久任务 "
    }), "\n", _jsx(_components.p, {
      children: "¥Persistent tasks without dependency awareness"
    }), "\n", _jsxs(_components.p, {
      children: ["某些工具与 monorepo 不兼容，并且不会在依赖中热重载模块。在这种情况下，你应该将任务标记为 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#interruptible",
        children: _jsx(_components.code, {
          children: "interruptible: true"
        })
      }), "，以便在检测到相关更改时让 ", _jsx(_components.code, {
        children: "turbo watch"
      }), " 重新启动该任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Some tools aren't monorepo-friendly, and do not hot-reload modules in dependencies. In those cases, you should\nmark the task as ", _jsx(_components.a, {
        href: "/docs/reference/configuration#interruptible",
        children: _jsx(_components.code, {
          children: "interruptible: true"
        })
      }), " to have ", _jsx(_components.code, {
        children: "turbo watch"
      }), "\nrestart the task when relevant changes are detected."]
    }), "\n", _jsx(_components.h2, {
      id: "限制-limitations",
      children: "限制 "
    }), "\n", _jsx(_components.p, {
      children: "¥Limitations"
    }), "\n", _jsx(_components.h3, {
      id: "缓存-caching",
      children: "缓存 "
    }), "\n", _jsx(_components.p, {
      children: "¥Caching"
    }), "\n", _jsxs(_components.p, {
      children: ["使用监视模式缓存任务目前处于实验阶段，使用 ", _jsx(_components.code, {
        children: "--experimental-write-cache"
      }), " 标志。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Caching tasks with Watch Mode is currently experimental, under the ", _jsx(_components.code, {
        children: "--experimental-write-cache"
      }), " flag."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " watch"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " your-tasks"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --experimental-write-cache"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "任务输出-task-outputs",
      children: "任务输出 "
    }), "\n", _jsx(_components.p, {
      children: "¥Task outputs"
    }), "\n", _jsx(_components.p, {
      children: "如果你的任务需要写入已签入源代码管理的文件，则监视模式可能会陷入无限循环。这是因为监视模式会监视文件更改，并会在发生更改的包中重新运行任务。如果任务创建了更改，则更改将再次触发该任务。"
    }), "\n", _jsx(_components.p, {
      children: "¥If you have tasks that write to files checked into source control, there is a possibility that Watch Mode will run in an infinite loop. This is because Watch Mode watches your\nfiles for changes and will re-run tasks in packages that have changed. If a task creates a change, then that will trigger the task again."
    }), "\n", _jsx(_components.p, {
      children: "监视模式有一些逻辑可以使用文件哈希来防止这种情况发生，但这并非万无一失。为避免此问题，我们建议从 git 中删除所有任务输出。"
    }), "\n", _jsx(_components.p, {
      children: "¥Watch Mode has some logic to prevent this from happening using file hashes, but it isn't foolproof. To avoid this issue, we recommend removing any task outputs from git."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
